<div class="grid grid-cols-1 md:grid-cols-6 gap-4" data-testid="project-references-filter">
  <div class="flex flex-col gap-2">
    <span>{{ 'common.search' | transloco }}</span>
    <app-global-search
      testId="project-references-search"
      [fullWidth]="true"
      (searchValue)="updateFilter('searchText', $event)"
    />
  </div>

  <app-model-field-multiselect
    id="project-references-filter-industry"
    label="project.steps.industry"
    [selectTranslatedOptions]="usedIndustryOptions()"
    [showClear]="true"
    [showSelectionLabel]="false"
    [value]="filter().industryIds"
    (valueChange)="updateFilter('industryIds', $event)"
  />

  <app-model-field-multiselect
    id="project-references-filter-countries"
    label="multiselect.select.country"
    [selectTranslatedOptions]="usedCountryOptions()"
    [showClear]="true"
    [showSelectionLabel]="false"
    [showCountryFlags]="true"
    [value]="filter().countryCodes"
    (valueChange)="updateFilter('countryCodes', $event)"
  />

  <app-model-field-multiselect
    id="project-references-filter-languages"
    label="project.steps.projectLanguage"
    [selectTranslatedOptions]="usedLanguageOptions()"
    [showClear]="true"
    [showSelectionLabel]="false"
    [value]="filter().languageCodes"
    (valueChange)="updateFilter('languageCodes', $event)"
  />

  <app-model-field-multiselect
    id="project-references-filter-functions"
    label="multiselect.select.function"
    [selectTranslatedOptions]="usedFunctionOptions()"
    [showClear]="true"
    [showSelectionLabel]="false"
    [value]="filter().functionIds"
    (valueChange)="updateFilter('functionIds', $event)"
  />

  <app-model-field-number
    id="project-references-filter-min-headcount"
    label="common.minEmployees"
    mode="integer"
    [showButtons]="true"
    [showClear]="true"
    [step]="50"
    [min]="0"
    [value]="filter().minHeadcount"
    (valueChange)="onMinHeadcountChange($event)"
  />
</div>
